import { Text } from '@change/ds-core-ui';
import { RaisedFistIcon } from '@change/ds-icons';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useSocialProofLabel } from '#src/app/shared/hooks/petition';

export const SocialProof: React.FC = () => {
	const {
		data: {
			petition: {
				dailySignatureCount,
				dailySignatureCountLocalized,
				weeklySignatureCount,
				weeklySignatureCountLocalized,
			},
			createdLessThanOneDayAgo,
		},
	} = usePetitionDetailsPageData();
	const textChildren = useSocialProofLabel({
		dailySignatureCount,
		dailySignatureCountLocalized,
		weeklySignatureCount,
		weeklySignatureCountLocalized,
		createdLessThanOneDayAgo,
	});
	return (
		<div className="rounded-large bg-fill-information-weaker flex items-center justify-center gap-2 p-2">
			<RaisedFistIcon />
			<Text size="small">{textChildren}</Text>
		</div>
	);
};
